@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Assigned Users"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="full_name" title="Name">
    <ng-template let-user kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="user.full_name" [link]="['/user', user.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="user_name" title="Email">
    <ng-template let-user kendoGridCellTemplate [unityTyped]="T">
      <unity-link-mailto-shared [variants]="['centered']" [emailAddress]="user.user_name" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="current_state.name" title="Status">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
